//props에 넘겨줘야 할 것들
// created_by: 회원, 선생님 여부, issuerId: userid로 전달할 id값.
import "../../css/modal/LessonModifyHistoryModal.css"
import {useEffect, useState} from "react";
import proxy from "../../utils/Proxy";
import LessonConstant from "../../utils/constants/LessonConstant";
import TeacherConstant from "../../utils/constants/TeacherConstant";
import Pagination from "../footer/Pagination";
import {getDateString, getFullTimeString, moveModal} from "../../utils/Utils";

let LessonModifyHistoryModal = (props) => {
    let [page, setPage] = useState(1);
    let [listLength, setListLength] = useState(0);
    let [historyList, setHistoryList] = useState([]);
    useEffect(() => {
        proxy.get("/adminapi/lessons/history/users/" + props.userid + "?page=" + page + "&count=" + 9).then(res => {
            let data = res.data;
            setListLength(data.totalLength)
            setHistoryList(data.data)

        }).catch(err => {
            window.alert(err.response.data.message)
        })
    }, [page, props.userid])

    let getCreatorName = (history) => {
        if (history.created_by === LessonConstant.created_by.USER) {
            return props.name;
        } else {
            let teacherid = history.created_id;
            let teacher = props.data.teachers[teacherid]
            if (!teacher)
                return ""
            return TeacherConstant.major_symbol[teacher.major] + teacher.name;
        }
    }

    let getHistoryCells = () => {
        let ret = [];
        for (let history of historyList) {
            let key = "lesson-history" + history.modifyid
            let timeStamp = new Date(history.time)
            ret.push(<div className="history-table-row" key={key}>
                <div className="history-element-cell">
                    <p>{LessonConstant.type_text[history.type]}</p>
                </div>
                <div className="history-element-cell">
                    <p>{getFullTimeString(timeStamp)}</p>
                </div>
                <div className="history-element-cell">
                    <p>{getDateString(new Date(history.lessondue)) + " " + history.lessonhour + "시"}</p>
                </div>
                <div className="history-element-cell">
                    <p>{LessonConstant.created_by_text[history.created_by]}</p>
                </div>
                <div className="history-element-cell">
                    <p>{getCreatorName(history)}</p>
                </div>
            </div>)
        }
        return ret;
    }

    return (<div className="modal-container child-modal-container">
        <div className="modal" id="lesson-history-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "lesson-history-modal")}>
                    <p className="modal-title">
                        레슨 예약/취소 내역
                    </p>
                    <div className="modal-close-button" onClick={() => {
                        props.setOpened(false)
                    }}></div>
                </div>
                <div className="modal-content lesson-history-content">
                    <div className="history-table-header">
                        <div className="history-element-cell">
                            <p className="history-header-text">분류</p>
                        </div>
                        <div className="history-element-cell">
                            <p className="history-header-text">일시</p>
                        </div>
                        <div className="history-element-cell">
                            <p className="history-header-text">레슨 일자</p>
                        </div>
                        <div className="history-element-cell">
                            <p className="history-header-text">생성자 분류</p>
                        </div>
                        <div className="history-element-cell">
                            <p className="history-header-text">생성자</p>
                        </div>
                    </div>
                    <div className="lesson-history-table">
                        {getHistoryCells()}
                    </div>
                </div>
                <div className="modal-footer">
                    <Pagination page={page} setPage={setPage.bind(this)} listLength={listLength}
                                countPerPage={9}></Pagination>
                </div>
            </div>
        </div>
    </div>)
}
export default LessonModifyHistoryModal